import React from "react"

const Tag = (props) => (
  <span className="rounded-lg border border-medium-grey bg-light-grey leading-0 p-2 shadow-lg">
    {props.children}
  </span>
)

export default Tag
